/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const lifecycleEntity = {

    entity: "lifecycle",
    label: "Lifecycle",

    fields: [

        {
            key: "lifecycle_id",
            label: "ID",
            type: "uuid",
            visible: false,
            editable: false
        },

        {
            key: "lifecycle_key",
            label: "Key",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "stage_key",
            label: "Stage",
            type: "text",
            visible: true,
            editable: true
        },

        {
            key: "stage_order",
            label: "Order",
            type: "number",
            visible: true,
            editable: true
        },

        {
            key: "active",
            label: "Active",
            type: "boolean",
            visible: true,
            editable: true
        }

    ]

}